export const EMAIL_REGEXP = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
